export type HorizontalAlign = 'left' | 'center' | 'right'
